<div class="flex flex-col gap-2 w-full my-2 box-border" [formGroup]="form">
    <div formArrayName="inputs" class="flex flex-col gap-2">
        @for (control of controls; track control; let index = $index) {
            <div class="flex gap-2 items-start">
                <sh-input-text
                    [formControlName]="index"
                    [label]="label()"
                    [disabled]="isDisabledInternal()"
                    [error]="hasError(control)"
                    (blur)="handleOnBlur()"
                    class="flex-1"
                >
                    <sh-icon
                        icon="user"
                        button
                        slot="icon"
                        state="showhide"
                        size="s"
                        (click)="openScdPicker(index)"
                        title="Look up user"
                    ></sh-icon>
                    @if (index > 0 && !isDisabledInternal()) {
                        <sh-icon
                            icon="delete"
                            button
                            slot="icon"
                            state="showhide"
                            (click)="removeInput(index)"
                        ></sh-icon>
                    }
                </sh-input-text>
            </div>
        }
    </div>

    @if (!isDisabledInternal()) {
        <div class="mt-2">
            <sh-button
                [label]="addButtonLabel()"
                icon="plus"
                icon-position="left"
                color="secondary"
                size="max-content"
                (click)="addInput()"
                [disabled]="isDisabledInternal()"
            ></sh-button>
        </div>
    }
</div>
